export default "__VITE_ASSET__sZ8eaLZK__"